import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import { ProfessionalPageOwnerModal } from '../../professional-page-owner-modal/ProfessionalPageOwnerModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { UserContext } from '../../../user/UserContext';
import styles from './lawyer_upload.module.scss';
import { VerifyLawyerModal } from '../../verify-lawyer-modal/VerifyLawyerModal';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { LawyerContext } from '../LawyerContext';

type Props = WithModalProps;

export const RawLawyerUpload: FC<Props> = ({ openModal }) => {
  const source = 'professional_upload_decision';
  const { currentUser, loggedIn } = useContext(UserContext);
  const {
    lawyerInfos,
    lawyerHasRetired,
    lawyerIsVerified,
    lawyerIsCurrentUser,
    lawyerName,
  } = useContext(LawyerContext);

  const openVerifyLawyerModal = () => {
    doctrineAnalytics('Professional WantToBeVerified', {
      source,
    });

    openModal(modalProps => (
      <VerifyLawyerModal
        lawyerId={lawyerInfos.lawyerId}
        lawyerName={lawyerName}
        {...modalProps}
      />
    ));
  };

  const openProfessionalPageOwnerModal = () => {
    doctrineAnalytics('Professional WantToEdit', {
      source,
    });

    openModal(modalProps => (
      <ProfessionalPageOwnerModal
        source={source}
        name={lawyerName}
        lawyerHasRetired={lawyerHasRetired}
        {...modalProps}
      />
    ));
  };

  const addLink = () => {
    if (!lawyerIsVerified && !currentUser.verified) {
      if (loggedIn) {
        return {
          onClick: () => openVerifyLawyerModal(),
        };
      }
      return {
        onClick: () => openProfessionalPageOwnerModal(),
      };
    }
    if (loggedIn && lawyerIsCurrentUser) {
      return { href: '/j/envoi', source: 'decisions_lawyer' };
    }
    return {};
  };

  const shouldDisplay =
    (!lawyerIsVerified && !currentUser.verified) ||
    ((lawyerIsVerified || currentUser.verified) &&
      loggedIn &&
      lawyerIsCurrentUser);

  if (!shouldDisplay) {
    return null;
  }

  return (
    <Hyperlink
      className={`button hollow large expanded ${styles.button}`}
      {...addLink()}
    >
      <span>
        <MaterialIcon name="upload" />
        <FormattedMessage id="app.pages.lawyer.upload" />
      </span>
    </Hyperlink>
  );
};

export const LawyerUpload = withModal(RawLawyerUpload);
